import { useQuery } from '@tanstack/react-query'

import { TANSTACK_QUERY_KEY } from '@/constants/tanstack-query'
import { IHttpError } from '@/data'

import {
  AccessCodeModel,
  IReferrerInfo,
  IReferrerInfoByReferralCode,
  IWalletReferralParams,
  IWalletReferralParamsByReferralCode,
} from '../models'

export function useQueryReferrerInfo(params: IWalletReferralParams) {
  return useQuery<IReferrerInfo, IHttpError>({
    queryKey: [TANSTACK_QUERY_KEY.ACCESS_CODE.GET_REFERRER_INFO, params?.walletAddress],
    queryFn: async () => {
      const response = await AccessCodeModel.getReferrerInfo(params)
      return response.data
    },
    enabled: !!params.walletAddress,
  })
}

export function useQueryReferrerInfoByReferralCode(params: IWalletReferralParamsByReferralCode) {
  return useQuery<IReferrerInfoByReferralCode, IHttpError>({
    queryKey: [TANSTACK_QUERY_KEY.ACCESS_CODE.GET_REFERRER_INFO_BY_REFERRAL_CODE, params?.referralCode],
    queryFn: async () => {
      const response = await AccessCodeModel.getReferrerInfoByReferralCode(params)
      return response.data
    },
    enabled: !!params.referralCode,
  })
}
